import { CanDeactivateFn } from '@angular/router';
import { CanComponentDeactivate } from './can-deactivate.interface';

export const canDeactivateAutopay: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
